export var WHITE = "white";
export var BLACK = "black";
export var RED = "red";
export var BACKGROUND_COLOR = "#e4e4f0";
export var BACKGROUND_COLOR_2 = '#F8F9FA';
export var TEXT_COLOR_1 = "#1F232E";
export var TEXT_COLOR_LIGHT = "#B4B8C1";
export var TAB_COLOR = "#eeeef5";
export var TAB_HOVER_COLOR = "#f4f5f6";
export var TAB_LABEL_COLOR = "#45474a";
export var TAB_ADD_BUTTON_HOVER_COLOR = "#ffffff26";
//# sourceMappingURL=colors.js.map